import React from 'react';

// Anillo con el avance del ciclo del cultivo.
const ProgressRing: React.FC<{ pct: number }> = ({ pct }) => {
  const r = 20;
  const c = 2 * Math.PI * r;
  return (
    <span className="lot-ring" aria-label={`Avance del ciclo ${pct}%`}>
      <svg viewBox="0 0 48 48" aria-hidden="true">
        <circle cx="24" cy="24" r={r} className="lot-ring-track" />
        <circle cx="24" cy="24" r={r} className="lot-ring-value" strokeDasharray={c} strokeDashoffset={c * (1 - Math.min(100, pct) / 100)} />
      </svg>
      <strong>{pct}%</strong>
    </span>
  );
};

export default ProgressRing;
